import { FC } from 'react'

import styled from 'styled-components'
import { notifications } from '@mantine/notifications'
import { useDisclosure } from '@mantine/hooks'

import { PageTitle } from 'src/Components/PageTitle/index.tsx'
import { colors, device } from 'src/Helpers/constants.ts'
import {
  useAddModelTypeMutation,
  useDeleteModelTypeMutation,
  useGetAllModelTypesQuery,
} from 'src/Redux/api/modelTypesApi.ts'
import { TransportTypeTable } from 'src/Pages/TransportSettingsPage/TransportTypeTable.tsx'
import IconCirclePlus from 'src/Assets/addButton.svg?react'
import { IconButton } from 'src/Components/Button/IconButton.tsx'
import {
  AddTransportTypeModal,
  AddTypeForm,
} from 'src/Pages/TransportSettingsPage/AddTransportTypeModal.tsx'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 36px;
  position: relative;
  height: 100%;
  overflow: hidden;
`

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 50px;
  position: static;

  @media ${device.tabletMax} {
    gap: 20px;
  }
`

const StyledButton = styled(IconButton)`
  svg {
    path {
      fill: ${colors.fourthBlue};
    }
  }
`

export const TransportSettingsPage: FC = () => {
  const [isAddModalOpened, { open: onOpenAddModal, close: onCloseAddModal }] =
    useDisclosure(false)

  const { data: modelTypes, isLoading } = useGetAllModelTypesQuery({
    all: true,
  })
  const [deleteMutation] = useDeleteModelTypeMutation()
  const [addType] = useAddModelTypeMutation()

  const onArchiveModelType = (id: number): void => {
    deleteMutation(id)
      .unwrap()
      .then(() => {
        notifications.show({
          title: 'Тип транспорта удален',
          message: '',
          position: 'top-right',
        })
      })
  }

  const onAddEquipment = (data: AddTypeForm): void => {
    if (data.name) {
      addType({
        label: data.name,
      })
    }
  }

  return (
    <Container>
      <TitleWrapper>
        <PageTitle>Настройки типов техники</PageTitle>

        <StyledButton
          onClick={onOpenAddModal}
          tooltiptext={'Добавить технику'}
          data-testid='add-transport-type'
        >
          <IconCirclePlus />
        </StyledButton>
      </TitleWrapper>

      <TransportTypeTable
        modelsTypes={modelTypes?.data}
        isLoading={isLoading}
        onArchiveItem={onArchiveModelType}
      />

      <AddTransportTypeModal
        onClose={onCloseAddModal}
        onAddType={onAddEquipment}
        isOpened={isAddModalOpened}
      />
    </Container>
  )
}
